const FOOTER_MEMBER = [
  {
    id: 1,
    name: '김한솔',
    img: 'images/man.png',
  },
  {
    id: 2,
    name: '김호준',
    img: 'images/man1.png',
  },
  {
    id: 3,
    name: '이명석',
    img: 'images/man2.png',
  },
  {
    id: 4,
    name: '조형진',
    img: 'images/man3.png',
  },
  {
    id: 5,
    name: '지송현',
    img: 'images/man4.png',
  },
  {
    id: 6,
    name: '홍석현',
    img: 'images/man5.png',
  },
  {
    id: 7,
    name: '박지영',
    img: 'images/girl.png',
  },
];
export default FOOTER_MEMBER;
